module.exports = __webpack_public_path__ + "img/badge.cf258dbe.svg";